// extracted by mini-css-extract-plugin
module.exports = {"rating":"filter-module__rating___3qgb0"};